<template>
    <div class="app-container">
        <el-alert
            title="注:以下所填数据在故障提交review之前都可以修改"
            type="info"
            style="margin-bottom: 10px"
        />
        <el-row>
            <el-col :span="12">
                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-width="120px"
                    size='mini'
                >
                    <el-form-item
                        label="故障简述"
                        prop="title"
                    >
                        <el-input
                            v-model="form.title"
                            placeholder="请填写故障的简洁描述"
                        />
                    </el-form-item>
                    <el-form-item label="故障级别">
                        <el-select
                            v-model="form.level"
                            style="display: block"
                            placeholder="请选择故障级别"
                        >
                            <el-option
                                v-for="item in level_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="业务线"
                        prop="category_1"
                    >
                        <el-select
                            v-model="form.category_1"
                            @change="reloadCategory2"
                        >
                            <el-option
                                v-for="item in category1_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="handleCategory1"
                        />
                    </el-form-item>
                    <el-form-item
                        label="项目名称"
                        prop="category"
                    >
                        <el-select
                            v-model="form.category"
                            placeholder="请先选择业务线"
                        >
                            <el-option
                                v-for="item in category2_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="handleCategory2"
                        />
                    </el-form-item>
                    <el-form-item label="发现方式">
                        <el-select
                            v-model="form.discovery"
                            style="display: block"
                        >
                            <el-option
                                v-for="item in discovery_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="故障详情"
                        prop="detail"
                    >
                        <el-input
                            v-model="form.detail"
                            :autosize="{ minRows: 6, maxRows: 6}"
                            type="textarea"
                            placeholder="例:QQ音乐访问量、考拉Fm访问异常，导致项目整体服务访问量降低，影响车机端部分功能，网关大量500告警"
                        />
                    </el-form-item>
                    <el-form-item
                        label="开始时间"
                        prop="start_time"
                    >
                        <el-date-picker
                            v-model="form.start_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请填写故障的产生时间"
                            style="width: 100%;"
                            @change="reloadDuration"
                        />
                    </el-form-item>
                    <el-form-item label="持续时长">
                        <el-input
                            v-model="form.duration"
                            :readonly="true"
                        />
                    </el-form-item>
                    <el-form-item
                        label="相关人员"
                        prop="users"
                    >
                        <el-select
                            v-model="form.users"
                            :remote-method="remoteMethod"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            style="display: block"
                        >
                            <el-option
                                v-for="item in options4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="责任部门">
                        <el-select
                            v-model="form.department"
                            multiple
                            filterable
                            style="display: block"
                        >
                            <el-option
                                v-for="item in departments"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="影响SLA">
                        <el-switch
                            v-model="form.sla"
                            active-text="是"
                            inactive-text="否"
                            active-value="1"
                            inactive-value="0"
                        />
                    </el-form-item>
                    <el-form-item label="故障进度">
                        <el-input
                            v-model="form.progress"
                            :autosize="{ minRows: 6, maxRows: 6}"
                            type="textarea"
                        />
                    </el-form-item>
                    <div v-if="status==='4'">
                        <h3>故障review</h3>
                        <el-form-item
                            label="关闭时间"
                            prop='deadline'
                        >
                            <el-date-picker
                                v-model="form.deadline"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="请填写故障恢复时间"
                                style="width: 100%;"
                            />
                        </el-form-item>
                        <el-form-item label="是否出具故障报告">
                            <el-switch
                                v-model="form.report"
                                active-text="是"
                                inactive-text="否"
                                active-value="1"
                                inactive-value="0"
                            />
                        </el-form-item>
                        <el-form-item label="故障原因">
                            <el-input
                                v-model="form.cause"
                                :autosize="{ minRows: 6, maxRows: 6}"
                                type="textarea"
                                placeholder="例:redis内存使用率过高"
                            />
                        </el-form-item>
                        <el-form-item label="影响产品">
                            <el-input
                                v-model="form.product"
                                placeholder="例:天气查询服务"
                            />
                        </el-form-item>
                        <el-form-item label="故障影响">
                            <el-input
                                v-model="form.affect"
                                :autosize="{ minRows: 6, maxRows: 6}"
                                type="textarea"
                                placeholder="例:造成5678次请求失败"
                            />
                        </el-form-item>
                        <el-form-item
                            label="问题与改进"
                            style='width:800px'
                        >
                            <div>
                                <el-button
                                    type='primary'
                                    @click='createchangedate("create")'
                                >新增改进点</el-button>
                            </div>
                            <el-table
                                :data="improvelist"
                                style="width:100%"
                                border
                                size='mini'
                            >
                                <el-table-column label="Jira ID">
                                    <template slot-scope="scope">
                                        <el-button
                                            type='text'
                                            @click="handitemclick(scope.row.jira_url)"
                                        >{{scope.row.jira_id}}</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    property="improve"
                                    label="改进点"
                                    width="120"
                                ></el-table-column>
                                <el-table-column
                                    property="fault"
                                    label="问题点"
                                    width="120"
                                ></el-table-column>
                                <el-table-column label="负责人">
                                    <template slot-scope="scope">
                                        <span
                                            v-for='(item, index) of Array.from(scope.row.users)'
                                            :key='index'
                                            style='margin: 0 5px'
                                        >{{item }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    property="deadline"
                                    label="交付时间"
                                    width="120"
                                ></el-table-column>
                                <el-table-column
                                    property="jira_status"
                                    label="状态"
                                    width="120"
                                ></el-table-column>
                                <el-table-column
                                    fixed="right"
                                    label="操作"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            @click.native.prevent="deleteRow(scope.$index, improvelist)"
                                            type="text"
                                            size="small"
                                        >移除</el-button>
                                        <el-button
                                            type="text"
                                            size="small"
                                            @click='createchangedate("change", scope.row.id)'
                                        >编辑</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>

                    </div>
                    <div v-else>
                        <div v-if="review=='1'">
                            <h3>故障review</h3>
                            <el-form-item
                                label="关闭时间"
                                prop='deadline'
                            >
                                <el-date-picker
                                    v-model="form.deadline"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请填写故障恢复时间"
                                    style="width: 100%;"
                                />
                            </el-form-item>
                            <el-form-item label="出具故障报告">
                                <el-switch
                                    v-model="form.report"
                                    active-text="是"
                                    inactive-text="否"
                                    active-value="1"
                                    inactive-value="0"
                                />
                            </el-form-item>
                            <el-form-item label="故障原因">
                                <el-input
                                    v-model="form.cause"
                                    :autosize="{ minRows: 6, maxRows: 6}"
                                    type="textarea"
                                    placeholder="例:redis内存使用率过高"
                                />
                            </el-form-item>
                            <el-form-item label="影响产品">
                                <el-input
                                    v-model="form.product"
                                    placeholder="例:天气查询服务"
                                />
                            </el-form-item>
                            <el-form-item label="故障影响">
                                <el-input
                                    v-model="form.affect"
                                    :autosize="{ minRows: 6, maxRows: 6}"
                                    type="textarea"
                                    placeholder="例:造成5678次请求失败"
                                />
                            </el-form-item>
                            <el-form-item
                                label="问题与改进"
                                style='width:800px'
                                size='mini'
                            >
                                <div>
                                    <el-button
                                        type='primary'
                                        @click='createchangedate("create")'
                                    >新增改进点</el-button>
                                </div>
                                <el-table
                                    :data="improvelist"
                                    style="width:100%;marginTop:15px"
                                    border
                                >
                                    <el-table-column label="Jira ID">
                                        <template slot-scope="scope">
                                            <el-button
                                                type='text'
                                                @click="handitemclick(scope.row.jira_url)"
                                            >{{scope.row.jira_id}}</el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        property="improve"
                                        label="改进点"
                                        width="120"
                                    ></el-table-column>
                                    <el-table-column
                                        property="fault"
                                        label="问题点"
                                        width="120"
                                    ></el-table-column>
                                    <el-table-column label="负责人">
                                        <template slot-scope="scope">
                                            <span
                                                v-for='(item, index) of Array.from(scope.row.users)'
                                                :key='index'
                                                style='margin: 0 5px'
                                            >{{item }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        property="deadline"
                                        label="交付时间"
                                        width="120"
                                    ></el-table-column>
                                    <el-table-column
                                        property="jira_status"
                                        label="状态"
                                        width="120"
                                    ></el-table-column>

                                    <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="120"
                                    >
                                        <template slot-scope="scope">
                                            <el-button
                                                @click.native.prevent="deleteRow(scope.$index, improvelist)"
                                                type="text"
                                                size="small"
                                            >移除</el-button>
                                            <el-button
                                                type="text"
                                                size="small"
                                                @click='createchangedate("change", scope.row.id)'
                                            >编辑</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="onCancel">取消</el-button>
                                <el-button
                                    type="primary"
                                    @click="handleSubmit"
                                >提交review</el-button>
                            </el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item>
                                <el-button
                                    type="success"
                                    @click="onSubmit"
                                >保存</el-button>
                                <el-button @click="onCancel">取消</el-button>
                                <el-button
                                    v-if='form.flow_status =="1"'
                                    type="danger"
                                    @click="onClose"
                                >结束故障</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </el-col>
        </el-row>
        <el-dialog
            :visible.sync="dialogCategory1Visible"
            title="新增业务线"
        >
            <el-form
                ref="category_1_form"
                :model="category_form"
                label-width="120px"
                size='mini'
            >
                <el-form-item
                    label="业务线名称"
                    prop="name"
                >
                    <el-input v-model="category_form.name" />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    @click="dialogCategory1Visible = false"
                    size='mini'
                >取 消</el-button>
                <el-button
                    type="primary"
                    @click="createCategory1"
                    size='mini'
                >确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogCategory2Visible"
            title="新增项目"
        >
            <el-form
                ref="category_2_form"
                :model="category_form"
                label-width="120px"
                size='mini'
            >
                <el-form-item
                    label="业务线"
                    prop="parent_id"
                >
                    <el-select
                        v-model="category_form.parent_id"
                        style="display: block"
                    >
                        <el-option
                            v-for="item in category1_list"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="项目名称"
                    prop="name"
                >
                    <el-input v-model="category_form.name" />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    @click="dialogCategory2Visible = false"
                    size='mini'
                >取 消</el-button>
                <el-button
                    type="primary"
                    @click="createCategory2"
                    size='mini'
                >确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <div>
                <el-form
                    ref="improveedit"
                    :model="form"
                    label-width="80px"
                    size='mini'
                >
                    <el-form-item label="改进点">
                        <el-input v-model="improveedit.improve"></el-input>
                    </el-form-item>
                    <el-form-item label="问题点">
                        <el-input
                            type="textarea"
                            v-model="improveedit.fault"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="负责人"
                        prop="users"
                    >
                        <el-select
                            v-model="improveedit.users"
                            :remote-method="remoteMethod"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            style="display: block"
                        >
                            <el-option
                                v-for="item in options4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交付时间">
                        <el-col>
                            <el-date-picker
                                type="datetime"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                v-model="improveedit.deadline"
                                style="width: 100%;"
                            >
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                </el-form>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    @click="dialogVisible = false"
                    size='mini'
                >取 消</el-button>
                <el-button
                    type="primary"
                    @click="onimproveedit"
                    size='mini'
                >确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
  eventInfo,
  editEvent,
  closeEvent,
  departmentList
} from "../../../services/fault/edit";
import {
  filterUser,
  levelList,
  discoveryList,
  categoryList,
  categoryChildren,
  addCategory
} from "../../../services/fault/new";
import {
  improveAdd,
  improveList,
  improveInfo,
  improveEdit,
  improveDelete
} from "../../../services/fault/improvement";
export default {
  data() {
    const checkUsers = (rule, value, callback) => {
      if (value.length < 2) {
        return callback(new Error("请选择至少2个相关人员"));
      } else {
        callback();
      }
    };
    return {
      level_list: [],
      discovery_list: [],
      category1_list: [],
      category2_list: [],
      departments: [],
      options4: [],
      list: [],
      loading: false,
      review: "0",
      status: "",
      form: {
        id: "",
        title: "",
        level: "",
        category_1: "",
        category: "",
        discovery: "",
        detail: "",
        start_time: "",
        duration: "",
        users: [],
        department: [],
        sla: "",
        progress: "",
        is_review: "0",
        deadline: "",
        report: "",
        affect: "",
        product: "",
        cause: "",
        current_user: ""
      },
      dialogCategory1Visible: false,
      dialogCategory2Visible: false,
      category_form: {
        name: "",
        parent_id: "",
        current_user: ""
      },
      rules: {
        title: [
          { required: true, message: "请输入故障简述", trigger: "blur" },
          { min: 1, max: 50, message: "最多50个字符", trigger: "blur" }
        ],
        category_1: [
          { required: true, message: "请选择业务线", trigger: "change" }
        ],
        category: [
          { required: true, message: "请选择项目", trigger: "change" }
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        users: [{ required: true, validator: checkUsers, trigger: "change" }],
        detail: [
          { required: true, message: "请输入故障详情", trigger: "blur" }
        ],
        deadline: [
          { required: true, message: "请输入关闭时间", trigger: "blur" }
        ]
      },
      params: {},
      dialogVisible: false,
      improvelist: [],
      improveedit: {
        improve: "",
        event_id: this.$route.query.event_id,
        fault: "",
        users: [],
        deadline: "",
        current_user: ""
      },
      improveinfo: {},
      title: ""
    };
  },
  mounted() {
    let id = this.$route.query.event_id;
    levelList().then(response => {
      this.level_list = response.level_data.map(item => {
        return {
          value: item.name,
          label: item.name + "(" + item.info.name + ")"
        };
      });
    });
    discoveryList().then(response => {
      this.discovery_list = response.discovery_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
    categoryList({ level: 1 }).then(response => {
      this.category1_list = response.category_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
    departmentList().then(response => {
      this.departments = response.department_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
    eventInfo(id).then(response => {
      categoryChildren({ category_id: response.category_1 }).then(response => {
        this.category2_list = response.category_data.map(item => {
          return { value: item.id, label: item.name };
        });
      });
      this.review = this.$route.query.review;
      this.status = response.status;
      this.form = {
        ...response,
        duration: response.duration
          ? response.duration
          : this.$options.methods.durationTime(response.start_time),
        progress: response.progress.join("\n"),
        current_user: this.$cookies.get("user_name")
      };
    });
    improveList(id).then(response => {
      this.improvelist = response.improve_data;
    });
  },
  methods: {
    reloadCategory2() {
      this.form.category = "";
      categoryChildren({ category_id: this.form.category_1 }).then(response => {
        this.category2_list = response.category_data.map(item => {
          return { value: item.id, label: item.name };
        });
      });
    },
    onSubmit() {
      this.params = Object.assign({}, this.form);
      this.params.progress = this.form.progress.split("\n");
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$refs.form.validate(valid => {
        if (valid) {
          editEvent(this.params).then(
            response => {
              this.$router.push({ path: "/fault/fault_table" });
              loading.close();
            },
            err => {
              loading.close();
              this.$message({ type: "error", message: err.message });
            }
          );
        } else {
          return false;
        }
      });
    },
    onCancel() {
      this.$router.push({ path: "/fault/fault_table" });
    },
    onClose() {
      this.$confirm("此操作将结束该故障, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.params = Object.assign({}, this.form);
          this.params.progress = this.form.progress.split("\n");
          closeEvent(this.params).then(
            response => {
              this.$router.push({ path: "/fault/fault_table" });
            },
            err => {
              this.$message({
                message: err.message,
                type: "error"
              });
            }
          );
        })
        .catch(() => {
          return false;
        });
    },
    handleSubmit() {
      this.$confirm("提交review审核，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          this.params = Object.assign({}, this.form);
          this.params.is_review = "1";
          this.params.progress = this.form.progress.split("\n");
          editEvent(this.params).then(
            response => {
              this.$router.push({ path: "/fault/fault_table" });
              loading.close();
            },
            err => {
              loading.close();
              this.$message({
                message: err.message,
                type: "error"
              });
            }
          );
        })
        .catch(() => {
          return false;
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        filterUser(query).then(response => {
          this.list = Object.keys(response.user_data).map(item => {
            return {
              value: item,
              label: response.user_data[item].name + "(" + item + ")"
            };
          });
        });
        setTimeout(() => {
          this.loading = false;
          this.options4 = this.list;
        }, 200);
      } else {
        this.options4 = [];
      }
    },
    durationTime(beginTime) {
      const dateBegin = new Date(beginTime);
      const dateEnd = new Date();
      const dateDiff = dateEnd.getTime() - dateBegin.getTime(); // 时间差的毫秒数
      const dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); // 计算出相差天数
      const leave1 = dateDiff % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
      const hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
      // 计算相差分钟数
      const leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
      const minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
      // 计算相差秒数
      const leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
      const seconds = Math.round(leave3 / 1000);
      let duration = minutes + "分" + seconds + "秒";
      if (hours > 0) {
        duration = hours + "小时" + minutes + "分" + seconds + "秒";
      }
      if (dayDiff > 0) {
        duration =
          dayDiff + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
      }
      return duration;
    },
    reloadDuration() {
      this.form.duration = this.$options.methods.durationTime(
        this.form.start_time
      );
    },
    handleCategory1() {
      this.dialogCategory1Visible = true;
      this.category_form.parent_id = "";
      this.category_form.name = "";
      this.category_form.current_user = this.$cookies.get("user_name");
    },
    handleCategory2() {
      this.dialogCategory2Visible = true;
      this.category_form.parent_id = this.category_form.parent_id
        ? this.category_form.parent_id
        : this.form.category_1;
      this.category_form.name = "";
      this.category_form.current_user = this.$cookies.get("user_name");
    },
    createCategory1() {
      this.$refs.category_1_form.validate(valid => {
        if (valid) {
          addCategory(this.category_form).then(
            response => {
              this.dialogCategory1Visible = false;
              categoryList({ level: 1 }).then(response => {
                this.category1_list = response.category_data.map(item => {
                  return { value: item.id, label: item.name };
                });
              });
            },
            err => {
              this.$message({ type: "error", message: err.message });
            }
          );
        } else {
          return false;
        }
      });
    },
    createCategory2() {
      this.$refs.category_2_form.validate(valid => {
        if (valid) {
          addCategory(this.category_form).then(
            response => {
              this.dialogCategory2Visible = false;
              categoryChildren({ category_id: this.form.category_1 }).then(
                response => {
                  this.category2_list = response.category_data.map(item => {
                    return { value: item.id, label: item.name };
                  });
                }
              );
            },
            err => {
              this.$message({ type: "error", message: err.message });
            }
          );
        } else {
          return false;
        }
      });
    },
    deleteRow(index, rows) {
      this.$confirm("此操作将永久删除该故障, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          improveDelete({ id: rows[index].id }).then(response => {
            rows.splice(index, 1);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    createchangedate(type, id) {
      // 修改添加改进点
      this.dialogVisible = true;
      if (type === "create") {
        this.title = "新增改进点";
      } else if (type === "change") {
        this.title = "修改改进点";
        improveInfo(id).then(res => {
          this.improveedit = res;
          this.user = res.users[0];
        });
      }
    },
    onimproveedit() {
      // 确认修改，添加改进点
      this.dialogVisible = false;
      if (this.title === "修改改进点") {
        let improveedit = this.improveedit;
        improveEdit(improveedit).then(
          res => {
            this.improvelist = this.improvelist.map(i => {
              if (i.id === improveedit.id) {
                i = improveedit;
              }
              return i;
            });
          },
          err => {
            this.$message({ type: "error", message: err.message });
          }
        );
      } else if (this.title === "新增改进点") {
        this.improveedit.event_id = this.$route.query.event_id;
        this.improveedit.current_user = this.$cookies.get("user_name");
        improveAdd(this.improveedit).then(
          res => {
            improveList(this.$route.query.event_id).then(response => {
              this.improvelist = response.improve_data;
            });
          },
          err => {
            this.$message.error(err.message);
          }
        );
      }
      this.improveedit = {
        improve: "",
        event_id: this.$route.query.event_id,
        fault: "",
        users: [],
        deadline: "",
        current_user: ""
      };
    },
    handitemclick(name) {
      let routeData = this.$router.resolve({ name });
      window.open(routeData.location.name, "_blank");
    }
  }
};
</script>
